import { ChatPage } from "./pages/ChatPage";
import type { PluginModule } from "../../plugins/types";

const charlieChatPlugin: PluginModule = {
  routes: [
    {
      path: "chat",
      element: <ChatPage />,
    },
  ],
  navigation: [
    {
      name: "Chat",
      route: "/chat",
      icon: "MessageCircle",
      order: 1,
    },
  ],
  config: {
    name: "charlieChat",
    version: "1.0.0",
    description: "Charlie AI concussion chat assistant",
  },
};

export default charlieChatPlugin;
